// src/components/LeadsCharts.js
import React from 'react';
import AreaChart from '../LineChart';

const calculateTotal = (values) => {
  return values.reduce((total, value) => total + parseInt(value, 10), 0);
};

const HotLeadsChart = ({ data }) => (
  <AreaChart 
    data={{ months: data.months, values: data['Hot Leads'] }} 
    title="Hot Leads"
    color={[255, 99, 132]} 
    label={`${data?.Total_Hot_Leads?data?.Total_Hot_Leads:0} Hot Leads`} 
  />
);

const ColdLeadsChart = ({ data }) => (
  <AreaChart 
    data={{ months: data.months, values: data['Cold Leads'] }} 
    title="Cold Leads"
    color={[54, 162, 235]} 
    label={`${data.Total_Cold_Leads?data.Total_Cold_Leads:0} Cold Leads`} 
  />
);

const WarmLeadsChart = ({ data }) => (
  <AreaChart 
    data={{ months: data.months, values: data['Warm Leads'] }} 
    title="Warm Leads"
    color={[255, 206, 86]} 
    label={`${data.Total_Warm_Leads?data.Total_Warm_Leads:0} Warm Leads`} 
  />
);

export { HotLeadsChart, ColdLeadsChart, WarmLeadsChart };
